import SalesHubBaromoneyMonthly from '@/entity/SalesHubBaromoneyMonthly';
/**
 * 허브 바로머니 월별 매출 뷰모델
 */
export default class SalesHubBaromoneyMonthlyVM extends SalesHubBaromoneyMonthly {
    // eslint-disable-next-line no-useless-constructor
    constructor(data) {
        super(data);
    }
}
